import { useEffect, useState } from "react";
import type { MouseEvent as ReactMouseEvent } from "react";

interface TocItem {
  id: string;
  heading: string;
}

export default function ArticleToc({ items }: { items: TocItem[] }) {
  const [activeId, setActiveId] = useState(items[0]?.id ?? "");

  useEffect(() => {
    const onScroll = () => {
      let current = items[0]?.id ?? "";
      items.forEach((item) => {
        const el = document.getElementById(item.id);
        if (el && el.getBoundingClientRect().top <= 140) {
          current = item.id;
        }
      });
      setActiveId(current);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [items]);

  const handleClick = (id: string) => (event: ReactMouseEvent) => {
    event.preventDefault();
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <nav aria-label="文章目录" className="rounded-lg border border-background-200 bg-background-50 p-5">
      <p className="mb-3 flex items-center gap-2 font-heading text-sm font-bold text-foreground-950">
        <i className="ri-list-unordered text-primary-600" aria-hidden="true"></i>
        本文目录
      </p>
      <ul className="space-y-2">
        {items.map((item, index) => (
          <li key={item.id}>
            <a
              href={`#${item.id}`}
              onClick={handleClick(item.id)}
              className={`flex gap-2 rounded-md px-2 py-1.5 text-sm transition-colors ${
                activeId === item.id
                  ? "bg-primary-100 font-medium text-primary-800"
                  : "text-foreground-600 hover:bg-background-100 hover:text-foreground-900"
              }`}
            >
              <span className="text-xs text-foreground-400">{String(index + 1).padStart(2, "0")}</span>
              {item.heading}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
}